<template>
  <div id="app" class="animated fadeIn">
    <BrandThemeLoading v-if="pendingStoreActions.includes('getBrandTheme')" />
    <router-view :class="{ 'is-offline': isOffline }" v-if="!pendingStoreActions.includes('getBrandTheme')"></router-view>
    <OfflineIndicator />
    <CookiesPolicy v-if="shouldShowCookiePolicy"
      @clickAcceptance="acceptCookiePolicy"
    />
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { hCreateNewStyleElementInDOM } from '@/utils/helpers';
  import store from '@/store';
  import OfflineIndicator from '@/components/Common/OfflineIndicator';
  import BrandThemeLoading from '@/components/Common/BrandThemeLoading';
  import CookiesPolicy from '@/components/Common/CookiesPolicy';

  export default {
    name: 'App',
    store,
    components: { OfflineIndicator, BrandThemeLoading, CookiesPolicy },
    async created() {
      this.shouldShowCookiePolicy = !localStorage.getItem('cookiesPolicyHasBeenAccepted');
      await this.getBrandTheme();
    },
    data() {
      return {
        shouldShowCookiePolicy: false,
      };
    },
    watch: {
      brandTheme(brandTheme) {
        if (brandTheme) {
          hCreateNewStyleElementInDOM(brandTheme);
        }
      },
    },
    computed: {
      ...mapGetters(['isOffline', 'pendingStoreActions', 'brandTheme']),
    },
    methods: {
      ...mapActions(['getBrandTheme']),
      acceptCookiePolicy() {
        this.shouldShowCookiePolicy = false;
        localStorage.setItem('cookiesPolicyHasBeenAccepted', true);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/App.vue